import imagesLoaded from "imagesloaded";
import Masonry from "masonry-layout";

import GetShareStats from "./get-share-stats";

export default class EntityLandingPage {
  constructor(args) {
    this.sidebar();
    this.setShares();
    // instantiate masonry on entity landing page.
    if ($(".campaigns-container").length) {
      imagesLoaded($(".campaigns-container"), () => {
        let msnry = new Masonry(".campaigns-container", {
          itemSelector: ".campaign-item",
          gutter: 20,
        });
      });
    }
  }

  sidebar() {
    const burgeredOut = $(".entity-landing-burger");

    if (burgeredOut.length > 0) {
      $(window).on("resize", () => {
        burgeredOut.next(".sidebar").removeClass("open");
        $("body").removeClass("entity-landing-burger-open");
      });
      burgeredOut.on("click", () => {
        burgeredOut.next(".sidebar").toggleClass("open");
        $("body").toggleClass("entity-landing-burger-open");
      });

      const closeDaBurger = $(".close-burger");

      closeDaBurger.on("click", (e) => {
        e.stopPropagation();
        $("body").toggleClass("entity-landing-burger-open");
        closeDaBurger.prev(".sidebar").toggleClass("open");
      });
    }
  }

  setShares() {
    if ($(".campaigns-container").length) {
      $(".campaign-item").each((index, item) => {
        const container = `.campaign-${index}`;
        const url = $(container).data("url");
        new GetShareStats(url, container);
      });
    }
  }
}
